/**
 * Get the value of a cookie
 *
 * @param cname cookie name
 * @return string
 */
export function getCookie(cname: string) {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }

        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }

    return '';
}

/**
 * Set a cookie value
 *
 * @param cname cookie name
 * @param cvalue cookie value
 * @param expirationDays expiration days (used only if persistent is true)
 * @param persistent whether the cookie should persist beyond the session
 */
export function setCookie(
    cname: string,
    cvalue: string | number | boolean | null | undefined,
    expirationDays: number | null | undefined = null,
    persistent: boolean = true
) {
    let cookie = `${cname}=${cvalue};path=/`;

    if (persistent) {
        if (!expirationDays) {
            expirationDays = 365;
        }

        const d = new Date();
        d.setTime(d.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
        cookie += `;expires=${d.toUTCString()}`;
    }

    if (getCookie('punch_out')) {
        cookie += ';SameSite=None;Secure';
    }

    document.cookie = cookie;
}
